/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoFusionModelsCustomProductListItem,
    MelcoFusionModelsCustomProductListItemFromJSON,
    MelcoFusionModelsCustomProductListItemFromJSONTyped,
    MelcoFusionModelsCustomProductListItemToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoFusionModelsCustomProductListItem
 */
export interface MelcoModelsGenericList1MelcoFusionModelsCustomProductListItem {
    /**
     * 
     * @type {Array<MelcoFusionModelsCustomProductListItem>}
     * @memberof MelcoModelsGenericList1MelcoFusionModelsCustomProductListItem
     */
    list: Array<MelcoFusionModelsCustomProductListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoFusionModelsCustomProductListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoFusionModelsCustomProductListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoFusionModelsCustomProductListItemFromJSON(json: any): MelcoModelsGenericList1MelcoFusionModelsCustomProductListItem {
    return MelcoModelsGenericList1MelcoFusionModelsCustomProductListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoFusionModelsCustomProductListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoFusionModelsCustomProductListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoFusionModelsCustomProductListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoFusionModelsCustomProductListItemToJSON(value?: MelcoModelsGenericList1MelcoFusionModelsCustomProductListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoFusionModelsCustomProductListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


